/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */


/**
 * Provides a mechanism to enable or disable selection interactions based on whether there
 * are multiple visualizations in a card or not.
 */
class Selection {

	constructor(context) {
		this.context = context;
	}

	isEnabled() {
		const {
			boardModel: { layout }
		} = this.context;


		const id = layout.exploreVM.displayedCard;
		const card = layout.findModel(id);
		const visualizations = card && card.getVisualizations();

		// Selection should be disabled for cards with only 1 visualization.
		return visualizations && visualizations.length > 1;
	}

}

export default Selection;



// WEBPACK FOOTER //
// ./src/js/layout/interactions/Selection.js